export default __webpack_public_path__ + "static/media/logo-no-text.59148238.svg";